import React, { useEffect, useState } from "react";
import { doc, onSnapshot} from "firebase/firestore";
import { db } from "../firebase";
import { useLocation } from "react-router-dom";
import jsPDF from "jspdf";


const DownloadTC = () => {
  const location = useLocation();
  const [studentDetails, setStudentDetails] = useState([]);

    useEffect(() => {
       onSnapshot(doc(db, "leavingCertificate", location.state.leavingId), (doc) => {
        let array=[]
        array.push({id:doc.id,...doc.data()})
      setStudentDetails(array);
    });
    }, []);

    // console.log(studentDetails);

  const download=()=>{
    var doc = new jsPDF('p','mm','a4');
        var img = new Image()
      var imgData =new Image()
      imgData.src = '../../assets/sail.png'
       img.src = '../../assets/as_logo.png'
      doc.addImage(img, 'png', 172, 12, 25, 25)
      doc.addImage(imgData, 'png', 10, 12, 25, 25)
      doc.setFontSize(15);
      doc.setFont("Times-Roman");
      doc.text(38, 18, 'BOKARO ISPAT SENIOR SECONDARY SCHOOL - 8B');
       
      doc.setFontSize(10);
      doc.setFont("Courier-BoldOblique");
      doc.text(55, 23, 'BOKARO STEEL PLANT');

      doc.setFontSize(10);
      doc.setFont("Courier-BoldOblique");
      doc.text(110, 23, 'CBSE Affiliation No. 3430077');

      doc.setFontSize(12);
      doc.setFont("Courier-BoldOblique",'normal');
      doc.text(68, 29, 'BOKARO STEEL CITY, JHARKHAND');

      doc.setFontSize(13);
      doc.setFont("Helvetica");
      doc.text(55, 37, 'SCHOOL LEAVING / TRANSFER CERTIFICATE');
      doc.setLineWidth(0.5);
      doc.line(54, 39, 157, 39);

      doc.setFontSize(11);
      doc.setFont("helvetica");
      doc.text(140, 49, "Admission No. :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(170, 49, studentDetails[0].admissionNo);


      doc.setFontSize(11);
      doc.text(11, 59, "1.");
      doc.setFont("helvetica");
      doc.text(16, 59, " Name of Pupil : ");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(70, 58, studentDetails[0].pupilFirstName);
      doc.text(75, 58, studentDetails[0].pupilMiddleName);
      doc.text(85, 58, studentDetails[0].pupilLastName);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(45, 59, 190, 59);

      doc.setFontSize(11);
      doc.text(11, 68, "2.");
      doc.setFont("helvetica");
      doc.text(16, 68, " Father's / Gaurdian's Name : ");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(70, 67, studentDetails[0].gaurdianFirstName);
      doc.text(75, 67, studentDetails[0].gaurdianMiddleName);
      doc.text(85, 67, studentDetails[0].gaurdianLastName);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(69, 68, 190, 68);

      doc.setFontSize(11);
      doc.text(11, 77, "3.");
      doc.setFont("helvetica");
      doc.text(16, 77, " Nationality : ");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(70, 76, studentDetails[0].nationality);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(40, 77, 190, 77);

      doc.setFontSize(11);
      doc.text(11, 86, "4.");
      doc.setFont("helvetica");
      doc.text(16, 86, " Whether the candidate belongs to Schedule Caste or Schedule Tribe : ");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(140, 85, studentDetails[0].candidateBelongs);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(138, 86, 190, 86);

      doc.setFontSize(11);
      doc.text(11, 95, "5.");
      doc.setFont("helvetica");
      doc.text(16, 95, " Date of first admission in the School with class : ");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(130, 94, studentDetails[0].firstAdmissionDate);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(99, 95, 190, 95);

      doc.setFontSize(11);
      doc.text(11, 104, "6.");
      doc.setFont("helvetica");
      doc.text(16, 104, " Date of Birth (in Christian Era) according to Admission Register :");
      doc.setFontSize(9);
      doc.setFont("helvetica");
      doc.text(127,104,"(in figures)")
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(150, 103, studentDetails[0].dateOfBirth);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(145, 104, 190, 104);
      doc.setFontSize(9);
      doc.setFont("helvetica");
      doc.text(20,110,"(in words)")
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(50, 109, studentDetails[0].dateOfBirthWord);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(35, 110, 190, 110);


      doc.setFontSize(11);
      doc.text(11, 117, "7.");
      doc.setFont("helvetica");
      doc.text(16, 117, " Class in which the pupil last studied :");
      doc.setFontSize(9);
      doc.setFont("helvetica");
      doc.text(80,117,"(in figures)")
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(110, 116, studentDetails[0].pupilLastStudid);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(97, 117, 125, 117);
      doc.setFontSize(9);
      doc.setFont("helvetica");
      doc.text(125,117,"(in words)")
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(155, 116, studentDetails[0].pupilLastStudidAlphabet);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(140, 117, 190, 117);



      doc.setFontSize(11);
      doc.text(11, 126, "8.");
      doc.setFont("helvetica");
      doc.text(16, 126, " School/Board Annual examination last taken with result :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(120, 125, studentDetails[0].schoolBoard);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(112, 126, 190, 126);

      doc.setFontSize(11);
      doc.text(11, 135, "9.");
      doc.setFont("helvetica");
      doc.text(16, 135, " Whether failed, if so once/twice in the same class :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(120, 134, studentDetails[0].failed);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(105, 135, 190, 135);

      doc.setFontSize(11);
      doc.text(9, 144, "10.");
      doc.setFont("helvetica");
      doc.text(15, 144, " Subject Studied :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(80, 143, studentDetails[0].failed);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(47, 144, 190, 144);


      doc.setFontSize(11);
      doc.text(9, 153, "11.");
      doc.setFont("helvetica");
      doc.text(15, 153, " Whether Qualified for promotion to higher class :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(130, 152, studentDetails[0].higherClass);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(102, 153, 190, 153);

      doc.setFontSize(11);
      doc.setFont("helvetica");
      doc.text(20, 159, " If so, to which class :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(100, 158, studentDetails[0].failed);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(58, 159, 190, 159);

      doc.setFontSize(11);
      doc.text(9, 168, "12.");
      doc.setFont("helvetica");
      doc.text(15, 168, " Month upto which the (pupil has paid) school dues paid :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(125, 167, studentDetails[0].schoolDues);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(115, 168, 190, 168);

      doc.setFontSize(11);
      doc.text(9, 177, "13.");
      doc.setFont("helvetica");
      doc.text(15, 177, "  Any fee concession availed of : if so, the nature of such concession :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(145, 176, studentDetails[0].feeConcession);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(138, 177, 190, 177);

      doc.setFontSize(11);
      doc.text(9, 186, "14.");
      doc.setFont("helvetica");
      doc.text(15, 186, " Total no. working days :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(80, 185, studentDetails[0].workingDays);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(60, 186, 190, 186);

      
      doc.setFontSize(11);
      doc.text(9, 195, "15.");
      doc.setFont("helvetica");
      doc.text(15, 195, " Total no. working days present :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(80, 194, studentDetails[0].workingDays);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(74, 195, 190, 195);


      doc.setFontSize(11);
      doc.text(9, 204, "16.");
      doc.setFont("helvetica");
      doc.text(15, 204, " Whether NCC Cadet/Boy Scout/Girl Guide (details may be given) :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(150, 203, studentDetails[0].nccCadet);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(133, 204, 190, 204);

      doc.setFontSize(11);
      doc.text(9, 213, "17.");
      doc.setFont("helvetica");
      doc.text(15, 213, " Games played or extra curricular activities in which the pupil usually took part ");
      doc.text(15, 220, "(mention achievement level therein) :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(130, 219, studentDetails[0].gamesPlayed);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(81, 220, 190, 220);

      doc.setFontSize(11);
      doc.text(9, 229, "18.");
      doc.setFont("helvetica");
      doc.text(15, 229, " General conduct :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(80, 228, studentDetails[0].generalConduct);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(48, 229, 190, 229);

      doc.setFontSize(11);
      doc.text(9, 238, "19.");
      doc.setFont("helvetica");
      doc.text(15, 238, " Date of application for certificate :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(100, 237, studentDetails[0].dateApplicationCertificate);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(76, 238, 190, 238);

      doc.setFontSize(11);
      doc.text(9, 247, "20.");
      doc.setFont("helvetica");
      doc.text(15, 247, " Date of issue for certificate :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(100, 246, studentDetails[0].dateIssueCertificate);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(67, 247, 190, 247);

      doc.setFontSize(11);
      doc.text(9, 256, "21.");
      doc.setFont("helvetica");
      doc.text(15, 256, " Reason for leaving the school :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(100, 255, studentDetails[0].reasonLeaving);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(71, 256, 190, 256);

      doc.setFontSize(11);
      doc.text(9, 265, "22.");
      doc.setFont("helvetica");
      doc.text(15, 265, " Any other remarks :");
      doc.setFontSize(12);
      doc.setFont("Courier");
      doc.text(100, 264, studentDetails[0].remarks);
      doc.setLineDash([.3, 2, .3, 2],0);
      doc.line(52, 265, 190, 265);

      doc.setFontSize(11);
      doc.setFont("helvetica");
      doc.text(20, 280, "Signature of ");
      doc.setFontSize(11);
      doc.setFont("helvetica");
      doc.text(22, 285, "Assistant");

      doc.setFontSize(11);
      doc.setFont("helvetica");
      doc.text(62, 280, "Signature of");
      doc.setFontSize(11);
      doc.setFont("helvetica");
      doc.text(60, 285, "Class Teacher");

      doc.setFontSize(11);
      doc.setFont("helvetica");
      doc.text(120, 280, "Checked By");
      doc.setFontSize(11);
      doc.setFont("helvetica");
      doc.text(100, 285, "(State full name and designation)");

      doc.setFontSize(11);
      doc.setFont("helvetica");
      doc.text(167, 280, "Principal");
      doc.setFontSize(11);
      doc.setFont("helvetica");
      doc.text(169, 285, "SEAL");


      doc.save(`${studentDetails[0].admissionNo}.pdf`);
  }

  
   return(
    <div className="w-full p-5 text-gray-700">
    <div className="grid grid-cols-7 gap-4">
    <div className='justify-items-center items-center' >
     <img src="../assets/sail.png" alt="pic" className='h-32 w-32' />
    </div>
    <div className="mb-2 text-center w-full col-span-5">
    <div className='mb-1 '> 
            <span className="font-bold  text-3xl ">
                BOKARO ISPAT SENIOR SECONDARY SCHOOL 8B
            </span>
    </div>
    <div className='grid grid-cols-9 gap-4'>
    <div className='mb-1 col-span-5 ml-10'> 
    <span className="text-xl ">
     BOKARO STEEL CITY, JHARKHAND
    </span>
    </div>
    <div className='mb-1 col-span-3'> 
    <span className="text-xl ">
             CBSE Affiliation No. 3430077
             </span>
    </div>
    </div>  
  <div className='mb-1 mt-5'> 
  <span className="block font-bold md:text-center mb-1 md:mb-0 pr-4 text-2xl underline underline-offset-8 ">
     SCHOOL LEAVING CERTIFICATE
    </span>
  </div>

    </div>
    <div className='justify-items-center items-center' >
     <img src="../assets/as_logo.png" alt="pic" className='h-32 w-32' />
    </div>
    </div>

    {studentDetails?.map((item, index) => (
      <div className="w-full mt-5 font-bold" key={index}>
     <div className="grid grid-cols-4 gap-4">
    <div className="md:flex md:items-center mb-6">
      <div className="md:w-1/3">
        <label
          className="block font-bold md:text-left mb-1 md:mb-0 "
          htmlFor="inline-full-name"
        >
          Book No.
        </label>
      </div>
      <div className="md:w-2/3">
        <div className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        ></div>
      </div>
    </div>
    <div className="md:flex md:items-center mb-6">
      <div className="md:w-1/4">
        <label
          className="block font-bold md:text-left mb-1 md:mb-0 "
          htmlFor="inline-full-name"
        >
          Sl No.
        </label>
      </div>
      <div className="md:w-4/5">
        <div  className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        > {++index}
        </div>
      </div>
    </div>

    <div className="md:flex md:items-center mb-6 col-span-2">
      <div className="md:w-1/3">
        <label
          className="block font-bold md:text-left mb-1 md:mb-0 "
          htmlFor="inline-full-name"
        >
          Admission No.
        </label>
      </div>
    <div className=" w-full py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
       >{item.admissionNo}</div>
     
    </div>
  </div>

  <div className=" w-full md:flex  md:items-center mb-6 ">
    <div className="mb-4 md:w-1/5">
      <label className="block  md:text-left mb-1 md:mb-0 ">
          Name of Pupil : 
      </label>
    </div>
    <div className="grid grid-cols-3 ">
   <div className=" w-full py-1.5 text-base font-normal text-gray-700 bg-white"
       >{item.pupilFirstName}</div>
   {item.pupilMiddleName.length>0 && <div className=" w-full py-1.5 text-base font-normal text-gray-700 bg-white"
       >{item.pupilMiddleName}</div>}
   <div className=" w-full py-1.5 text-base font-normal text-gray-700 bg-white "
        >{item.pupilLastName}</div>
 </div>
  </div>
  <div className=" w-full md:flex  md:items-center mb-6 ">
    <div className="mb-4 md:w-1/5">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
      >
        Father's/Gaurdian's Name
      </label>
    </div>
    <div className="grid grid-cols-3 ">
   <div className=" w-full py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
       >{item.gaurdianFirstName}</div>
   <div className=" w-full py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
       >{item.gaurdianMiddleName}</div>
   <div className=" w-full py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        >{item.gaurdianLastName}</div>
 </div>
  </div>
  <div className=" w-full md:flex  md:items-center mb-6 ">
    <div className="mb-4 md:w-1/5">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
      >
        Nationality :
      </label>
    </div>
   <div className="block w-64 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
    >{item.nationality}</div>
    </div>
 

  <div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/2">
      <label
        className="block  md:text-left mb-1 md:mb-0 " 
      >
        Whether the candidate belongs to Schedule Caste or Schedule Tribe 
      </label>
    </div>
    <div className="md:w-1/6">
    <div className="block w-64 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
    >{item.candidateBelongs}</div></div>
   
  </div>
  <div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/2">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
      >
        Date of first admission in the School with class
      </label>
    </div>
    <div className="md:w-1/6">
   <div className=" w-full py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
      >{item.firstAdmissionDate?.split('-').reverse().join('-')}</div></div>
  </div>

  <div className="pt-1">
        <label
          className="block  md:text-left mb-1"
          htmlFor="inline-full-name"
        >
          Date of Birth (in Christian Era) according to Admission Register
        </label>
      
  <div className="grid grid-cols-2 gap-4">
    <div className="md:flex md:items-center mb-6">
      <div className="md:w-1/6">
        <label
          className="block  md:text-left mb-1 md:mb-0 "
          htmlFor="inline-full-name"
        >
          (in figures)
        </label>
      </div>
      <div className="md:w-5/6">
      <div
        className=" w-96 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
         >{item.dateOfBirth?.split('-').reverse().join('-')}</div>
    </div>
    </div>

    <div className="md:flex md:items-center mb-6">
      <div className="md:w-1/6">
        <label
          className="block  md:text-left mb-1 md:mb-0 "
          htmlFor="inline-full-name"
        >
          (in words)
        </label>
      </div>
      <div className="md:w-5/6">
        <div
          className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
      >{item.dateOfBirthWord}</div>
      </div>
    </div>
  </div>
</div> 
<div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/3">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
        htmlFor="inline-full-name"
      >
        Class in which the pupil last studied
      </label>
    </div>
    
    <div className="grid grid-cols-2 gap-4 md:w-2/3">
    <div className="md:flex md:items-center mb-6">
      <div className="md:w-1/2">
        <label
          className="block  md:text-left mb-1 md:mb-0 "
          htmlFor="inline-full-name"
        >
          (in figures)
        </label>
      </div>
      <div className="md:w-5/6">
        <div
        className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        >{item.pupilLastStudid}</div>
      </div>
    </div>

    <div className="md:flex md:items-center mb-6">
      <div className="md:w-1/6">
        <label
          className="block  md:text-left mb-1 md:mb-0 "
          htmlFor="inline-full-name"
        >
          (in words)
        </label>
      </div>
      <div className="md:w-5/6">
        <div
      className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        >{item.pupilLastStudidAlphabet}</div>
      </div>
    </div>
  </div>
    </div>

    <div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/2">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
        htmlFor="inline-full-name"
      >
        School/Board Annual examination last taken with result
      </label>
    </div>
    <div className="md:w-1/6">
      <div
        className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        >{item.schoolBoard}</div>
    </div>
  </div>

  <div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/2">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
        htmlFor="inline-full-name"
      >
        Whether failed, if so once/twice in the same class
      </label>
    </div>
    <div className="md:w-2/3">
    <div 
  className=" block w-64 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
      >{item.failed}</div>
    </div>
  </div>

  <div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/6">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
        htmlFor="inline-full-name"
      >
        Subject Studied
      </label>
    </div>
    
    <div className="grid grid-cols-6 gap-4 md:w-5/6">
    <div className="md:flex md:items-center mb-6">
      <div className="md:w-1/6">
        <label
          className="block  md:text-left mb-1 md:mb-0 "
          htmlFor="inline-full-name"
        >
          1
        </label>
      </div>
      <div className="md:w-5/6">
        <input
          type="text"           
          className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        />
      </div>
    </div>

    <div className="md:flex md:items-center mb-6">
      <div className="md:w-1/6">
        <label
          className="block  md:text-left mb-1 md:mb-0 "
          htmlFor="inline-full-name"
        >
         2
        </label>
      </div>
      <div className="md:w-5/6">
        <input
          type="text"           
          className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        />
      </div>
    </div>
    <div className="md:flex md:items-center mb-6">
      <div className="md:w-1/6">
        <label
          className="block  md:text-left mb-1 md:mb-0 "
          htmlFor="inline-full-name"
        >
          3
        </label>
      </div>
      <div className="md:w-5/6">
        <input
          type="text"           
          className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        />
      </div>
    </div>
    <div className="md:flex md:items-center mb-6">
      <div className="md:w-1/6">
        <label
          className="block  md:text-left mb-1 md:mb-0 "
          htmlFor="inline-full-name"
        >
          4
        </label>
      </div>
      <div className="md:w-5/6">
        <input
          type="text"           
          className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        />
      </div>
    </div>
    <div className="md:flex md:items-center mb-6">
      <div className="md:w-1/6">
        <label
          className="block  md:text-left mb-1 md:mb-0 "
          htmlFor="inline-full-name"
        >
          5
        </label>
      </div>
      <div className="md:w-5/6">
        <input
          type="text"           
          className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        />
      </div>
    </div>
    <div className="md:flex md:items-center mb-6">
      <div className="md:w-1/6">
        <label
          className="block  md:text-left mb-1 md:mb-0 "
          htmlFor="inline-full-name"
        >
          6
        </label>
      </div>
      <div className="md:w-5/6">
        <input
          type="text"
          className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        />
      </div>
    </div>
  </div>
    </div>


    <div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/2">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
        htmlFor="inline-full-name"
      >
        Whether Qualified for promotion to higher class
      </label>
    </div>
    <div className="md:w-1/5">
      <div
        className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
      >{item.higherClass}</div>
    </div>
  </div>

  <div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/6">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
        htmlFor="inline-full-name"
      >
        If so, to which class
      </label>
    </div>
    
    <div className="grid grid-cols-2 gap-4 md:w-5/6">
    <div className="md:flex md:items-center mb-6">
      <div className="md:w-1/5">
        <label
          className="block  md:text-left mb-1 md:mb-0 "
          htmlFor="inline-full-name"
        >
          (in figures)
        </label>
      </div>
      <div className="md:w-4/5">
        <div          
          className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        >{item.whichClass}</div>
      </div>
    </div>

    <div className="md:flex md:items-center mb-6">
      <div className="md:w-1/6">
        <label
          className="block  md:text-left mb-1 md:mb-0 "
          htmlFor="inline-full-name"
        >
          (in words)
        </label>
      </div>
      <div className="md:w-5/6">
        <input
          type="text"
          className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
        />
      </div>
    </div>
  </div>
    </div>

    <div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/2">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
        htmlFor="inline-full-name"
      >
        Month upto which the (pupil has paid) school dues paid
      </label>
    </div>
    <div className="md:w-1/5">
      <div
        className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
      >{item.schoolDues}</div>
    </div>
  </div>

  <div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/2">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
        htmlFor="inline-full-name"
      >
        Any fee concession availed of : if so, the nature of such concession
      </label>
    </div>
    <div className="md:w-3/5">
    <div 
    className=" block w-64 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                >{item.feeConcession}</div>
    </div>
  </div>
  <div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/5">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
        htmlFor="inline-full-name"
      >
        Total no. working days
      </label>
    </div>
    <div className="md:w-3/4">
      <div
        className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
      >{item.workingDays}</div>
    </div>
  </div>
  <div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/2">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
        htmlFor="inline-full-name"
      >
        Whether NCC Cadet/Boy Scout/Girl Guide (details may be given)
      </label>
    </div>
    <div className="md:w-2/3">
    <div 
     className=" block w-64 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                 >{item.nccCadet}</div>
    </div>
  </div>

  <div className="w-full md:flex  md:items-center">
  <div className="mb-4 md:w-5/6">
        <label
          className="block  md:text-left mb-1  "
          htmlFor="inline-full-name"
        >
        Games played or extra curricular activities in which the pupil usually took part (mention achievement level therein)
        </label>
        </div>
    <div className="md:flex md:items-center mb-6 md:w-1/5">
    <div 
      className="  block w-64 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
    >{item.gamesPlayed}</div>
      </div>
 
</div> 
  <div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/4">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
        htmlFor="inline-full-name"
      >
        General conduct :
      </label>
    </div>
    <div className="md:w-1/2">
       <div 
       className=" block w-64 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                 >{item.generalConduct}</div>
              </div>
  </div>
  <div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/4">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
        htmlFor="inline-full-name"
      >
        Date of application for certificate :
      </label>
    </div>
    <div className="md:w-1/4">
      <div
        className=" w-full py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
     >{item.dateApplicationCertificate?.split('-').reverse().join('-')}</div>
    </div>
  </div>
  <div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/5">
      <label
        className="block md:text-left mb-1 md:mb-0 "
        htmlFor="inline-full-name"
      >
        Date of issue for certificate :
      </label>
    </div>
    <div className="md:w-1/3">
      <div
        className=" w-full py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
     >{item.dateIssueCertificate?.split('-').reverse().join('-')}</div>
    </div>
  </div>
  <div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/5">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
        htmlFor="inline-full-name"
      >
        Reason for leaving the school :
      </label>
    </div>
    <div className="md:w-1/3">
      <div
        className=" w-full   py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
    >{item.reasonLeaving}</div>
    </div>
  </div>
  <div className=" w-full md:flex  md:items-center ">
    <div className="mb-4 md:w-1/5">
      <label
        className="block  md:text-left mb-1 md:mb-0 "
        htmlFor="inline-full-name"
      >
        Any other remarks :
      </label>
    </div>
    <div className="md:w-4/5">
      <div
        className=" w-full py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
      >{item.remarks}</div>
    </div>
  </div>

  <div className='grid grid-cols-4 gap-4 mt-10'>
    <div className='font-bold '>
        <span>Signature of
        <br/> Asstt.</span>
    </div>
    <div className='font-bold '>
    <span>Signature of
    <br/> Class teacher</span>
    </div>
    <div className='font-bold '>
    <span>Checked by 
        <br/>
        (State full name and designation)
        </span>
    </div>
    <div className='font-bold '>
        <span>Principal
            <br/>
             SEAL</span>
    </div>
  </div>
  </div>
    ))}
  <div className="mt-4 ">
    <button
    onClick={download}
      className="w-32 py-1.3 bg-blue-400  text-2xl text-white font-semibold"
    >
      Download
    </button>
  </div>
</div>
   )
}

export default DownloadTC